import {
  faCloudDownloadAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import './About.scss';
import Experience from "./Experience/Experience";

const About = () => {
  const Download = <FontAwesomeIcon icon={faCloudDownloadAlt} />;

  return (
    <Container id="about">
      <h1
        style={{ textTransform: "uppercase", color: "#100028", }}
        className="mb-4 mt-4 mt-lg-0 lg-5 text-center headline"
      >
      ABOUT MYSELF
      </h1>
      <Row>
        <Col className="pb-5 about-myself" md={12} lg={6}>
          <h5 style={{ color: "#100028"}}className="text-center mb-3">Personal Details</h5>
          <p className="text-justify">
           Hi there, I am a professional Full-stack Web Developer offering 2 years of working experience in mid to large company. During my job, I provide highly-impact web solutions for diverse projects. Also I develope new user-facing features,Troubleshooting and fixing bugs, Collaborating with designer team, Covert design into business logic, Maintaining software workflow, Providing support to backend developers and stakeholders, Researching different software programs and came up with new solutions, Monitoring and improving front-end performance, Working on Agile and Scrum base environment. I am very familiar with modern web technologies and web development lifecycle.
          </p>
          <Row>
            <Col md={6} className="about">
              <ul>
                <li>
                  Github:{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.github.com/arif286"
                  >
                    arif286
                  </a>
                </li>
                <li>Email: nurulalamarif2@gmial.com</li>
                <li>Address: Senbagh, Noakhali, Bangladesh</li>
              </ul>
            </Col>
            <Col md={6} className="about">
              <ul>
                <li>
                  LinkedIn:{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/in/nurulalam21"
                  >
                    Nurul Alam
                  </a>
                </li>
                <li>Phone: +8801840300379</li>
                <li>Nationality: Bangladeshi</li>
              </ul>
            </Col>
          </Row>
          <button>
            <a href="https://drive.google.com/file/d/1LFKk9eaPZrcywo7ErX2XbSGjPvSLrUCY/view?usp=sharing">
              <span className="mr-2">{Download}</span> my resume
            </a>
          </button>
        </Col>
        <Col className="pb-5" md={12} lg={6}>
          <h5 style={{ color: "#100028" }} className="mb-4 text-center">
            Experience & Education
          </h5>
          <Experience />
        </Col>
      </Row>
    </Container>
  );
};

export default About;
